export default {
    API_ENDPOINT: 'https://warm-castle-96285.herokuapp.com/api'
  }